module.exports = __webpack_public_path__ + "static/media/1POLICY17.d180fce9.jpg";